<template>
  <div>
    <div class="title">비상연락체계</div>
    <div class="print-container">
      <h5 class="mb-5"><i class="dot"></i> 사내 연락체계</h5>
      <table>
        <thead>
          <tr>
            <th>구분</th>
            <th>직책</th>
            <th>연락처</th>
            <th>임무 및 역할</th>
            <th>관련 웹사이트</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(data, data_i) in form.inside" :key="data_i">
            <td>
              <div>{{ data.input1 || "-" }}</div>
            </td>
            <td>
              <div>{{ data.input2 || "-" }}</div>
            </td>
            <td>
              <div>{{ data.input3 || "-" }}</div>
            </td>
            <td>
              <div class="print-textarea no-block text-center">{{ data.input4 || "-" }}</div>
            </td>
            <td class="link">
              <div>{{ data.input5 || "-" }}</div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="print-container mt-10">
      <h5 class="mb-5"><i class="dot"></i> 사외 연락체계</h5>
      <table>
        <colgroup></colgroup>
        <thead>
          <th>구분</th>
          <th>연락처</th>
          <th>비고</th>
          <th>임무 및 역할</th>
          <th>관련 웹사이트</th>
        </thead>
        <tbody>
          <tr v-for="(data, data_i) in form.outside" :key="data_i">
            <td>
              <div>{{ data.input1 || "-" }}</div>
            </td>
            <td>
              <div>{{ data.input2 || "-" }}</div>
            </td>
            <td>
              <div>{{ data.input3 || "-" }}</div>
            </td>
            <td>
              <div class="print-textarea no-block text-center">{{ data.input4 || "-" }}</div>
            </td>
            <td class="link">
              <div>{{ data.input5 || "-" }}</div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
export default {
  name: "Print",
  props: {
    form: Object,
  },
};
</script>
<style lang="scss" scoped>
.title {
  font-size: 24px;
  font-weight: 700;
  line-height: 35px;
  padding: 20px 0;
  margin-bottom: 40px;
}

h5 {
  font-size: 20px;
  font-weight: 500;
  margin-bottom: 21px;
}

table {
  width: 100%;
  table-layout: fixed;
  border-collapse: collapse;

  th,
  td {
    border: 1px solid #000;
    padding: 15px 8px;

    font-size: 14px;
    font-weight: 500;
    text-align: center;

    border: 1px solid #cdcdcd;
  }

  th {
    font-weight: 500;
    color: #3c3c3c;
    background: #f9f9f9;
  }

  td {
    font-weight: 400;
    color: #3c3c3c;
    word-break: break-all;
    box-sizing: content-box;

    &.link {
      color: #0085ff;
    }

    div {
      min-height: 18px;
    }
  }
}

.print-textarea.no-block {
  min-height: 0;
}
</style>
